import React from "react";
import { Link } from "react-router-dom";

const Capabilities = () => {
  const container = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "120px 20px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    color: "#ffffff",
  };

  const sectionTitle = {
    fontSize: "0.85rem",
    color: "#00d4ff",
    letterSpacing: "3px",
    textTransform: "uppercase",
    marginBottom: "15px",
    fontWeight: "700",
  };

  const grid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
    gap: "30px",
    marginTop: "50px",
  };

  const card = {
    background: "rgba(255,255,255,0.03)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "24px",
    padding: "40px",
    transition: "all 0.3s ease",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  const listStyle = {
    paddingLeft: "20px",
    color: "#8b949e",
    fontSize: "0.95rem",
    lineHeight: "1.8",
  };

  return (
    <div style={{ backgroundColor: "#05070a", minHeight: "100vh" }}>
      <div style={container}>
        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: "80px" }}>
          <h4 style={sectionTitle}>Innovation • Elevation • Acceleration</h4>
          <h1 style={{ fontSize: "clamp(2.5rem, 5vw, 4rem)", fontWeight: "900", marginBottom: "25px" }}>
            Our Technical <span style={{ color: "#00d4ff" }}>Capabilities</span>
          </h1>
          <p style={{ fontSize: "1.15rem", color: "#a0aab4", maxWidth: "800px", margin: "0 auto" }}>
            We provide a gateway to uncovering abilities and exploring limitless opportunities in the world of technology.
          </p>
        </div>

        {/* CARDS GRID */}
        <div style={grid}>
          {/* Business Analysis */}
          <div style={card}>
            <div>
              <h3 style={{ fontSize: "1.5rem", marginBottom: "15px" }}>Business Analysis</h3>
              <p style={{ color: "#a0aab4", marginBottom: "20px" }}>
                Comprehensive market research and data-driven insights using modern analytics.
              </p>
              <ul style={listStyle}>
                <li>Tableau & Power BI Integration</li>
                <li>Competitor Benchmarking & Gap Analysis</li>
                <li>SWOT & Risk Assessment</li>
                <li>Customer Behavior Analysis</li>
              </ul>
            </div>
          </div>

          {/* Mobile App Development */}
          <div style={card}>
            <div>
              <h3 style={{ fontSize: "1.5rem", marginBottom: "15px" }}>Mobile App Development</h3>
              <p style={{ color: "#a0aab4", marginBottom: "20px" }}>
                Full-cycle mobile app development for Android & iOS, delivering seamless user experiences.
              </p>
              <ul style={listStyle}>
                <li>React Native & Flutter Development</li>
                <li>Performance & Security Optimization</li>
                <li>API Integration & Backend Connectivity</li>
                <li>App Store Deployment & Support</li>
              </ul>
            </div>
          </div>

          {/* Integrations (GCP / CP4I) */}
          <div style={card}>
            <div>
              <h3 style={{ fontSize: "1.5rem", marginBottom: "15px" }}>Integrations</h3>
              <p style={{ color: "#a0aab4", marginBottom: "20px" }}>
                Seamless enterprise integrations across cloud and on-premise platforms.
              </p>
              <ul style={listStyle}>
                <li>IBM CP4I & API Connect Implementations</li>
                <li>GCP Cloud Integrations</li>
                <li>Third-party System Connectivity</li>
                <li>Automated Data Pipelines & ETL</li>
              </ul>
            </div>
          </div>

          {/* CI/CD & DevOps */}
          <div style={card}>
            <div>
              <h3 style={{ fontSize: "1.5rem", marginBottom: "15px" }}>CI/CD & DevOps</h3>
              <p style={{ color: "#a0aab4", marginBottom: "20px" }}>
                Enabling continuous delivery with automated workflows and modern DevOps practices.
              </p>
              <ul style={listStyle}>
                <li>Pipeline Automation & Deployment</li>
                <li>Infrastructure as Code (IaC)</li>
                <li>Monitoring & Performance Optimization</li>
                <li>Version Control & Release Management</li>
              </ul>
            </div>
          </div>

         

          {/* Strategic Consulting */}
          <div style={card}>
            <div>
              <h3 style={{ fontSize: "1.5rem", marginBottom: "15px" }}>Strategic Consulting</h3>
              <p style={{ color: "#a0aab4", marginBottom: "20px" }}>
                Detailed performance evaluation and customized expansion roadmaps.
              </p>
              <ul style={listStyle}>
                <li>Revenue & Profitability Roadmap</li>
                <li>KPI & Success Measurement Framework</li>
                <li>Execution & Implementation Planning</li>
                <li>Customized Growth Strategies</li>
              </ul>
            </div>
          </div>

          {/* AI & Resource Augmentation */}
          <div style={card}>
            <div>
              <h3 style={{ fontSize: "1.5rem", marginBottom: "15px" }}>AI & Resource Augmentation</h3>
              <p style={{ color: "#a0aab4", marginBottom: "20px" }}>
                Specialized in technical mentorship and groundbreaking AI technologies.
              </p>
              <ul style={listStyle}>
                <li>AI Automation Solutions</li>
                <li>Custom SAP Support & Implementation</li>
                <li>Resource Augmentation for Scale</li>
                <li>Technical Mentorship & Growth</li>
              </ul>
            </div>
          </div>
        </div>

        {/* RETURN BUTTON */}
        <div style={{ textAlign: "center", marginTop: "80px" }}>
          <Link
            to="/"
            style={{
              padding: "18px 50px",
              background: "#00d4ff",
              color: "#05070a",
              borderRadius: "50px",
              textDecoration: "none",
              fontWeight: "800",
              boxShadow: "0 10px 30px rgba(0, 212, 255, 0.3)",
            }}
          >
            Return to Headquarters
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Capabilities;